export function generateSessionId(): string {
    return crypto.randomUUID();
}

export function normalizeSdp(sdp: string): string {
    return sdp.replace(/\r\n/g, '\n') + '\n';
}

export function buildWebRTCPlayRequest(sourceId: string) {
    return {
        command: 'play' as const,
        source: sourceId,
        range: 'now-',
    };
}
